export default __webpack_public_path__ + "static/media/_calendar_icon.0e86f21a.svg";